import { render } from "./LinkChainIcon.vue?vue&type=template&id=244fa22b"
import script from "./LinkChainIcon.vue?vue&type=script&lang=js"
export * from "./LinkChainIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Icons/LinkChainIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "244fa22b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('244fa22b', __exports__)) {
    api.reload('244fa22b', __exports__)
  }
  
  module.hot.accept("./LinkChainIcon.vue?vue&type=template&id=244fa22b", () => {
    api.rerender('244fa22b', render)
  })

}


export default __exports__